module.exports = __webpack_public_path__ + "icon-pencil-lake.5dc6a0720decaf400916.svg";